class ScenceImageSwiperSection extends HTMLElement {
    constructor() {
        super();

        this.buttonSwiperContainer = this.querySelector('.scene-image-swiper-button-swiper');
        this.imageSwiperContainer = this.querySelector('.scene-image-swiper-image-swiper');

        if (!this.buttonSwiperContainer || !this.imageSwiperContainer) return;

        this.init();
    }

    init() {
        const buttonSwiper = new Swiper(this.buttonSwiperContainer, {
            slidesPerView: 5,
            spaceBetween: 20,
            centeredSlides: false,
            slideToClickedSlide: true,
            loop: false,
            watchSlidesProgress: true,
            allowTouchMove: false,
            breakpoints: {
                320: {  //当屏幕宽度大于等于320
                    slidesPerView: 'auto',
                    allowTouchMove: true,
                },
                1001: {  //当屏幕宽度大于等于768 
                    slidesPerView: 5,
                },
            }
        });

        const imageSwiper = new Swiper(this.imageSwiperContainer, {
            loop: false,
            spaceBetween: 20,
            slideToClickedSlide: true,
            watchSlidesProgress: true,
            thumbs: {
                swiper: buttonSwiper,
            }
        });
    }
}

customElements.define('scence-image-swiper-section', ScenceImageSwiperSection);
